import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useGuardrailPolicies(organizationId: string) {
  return useQuery(
    orpc.guardrailPolicies.list.queryOptions({
      input: { organizationId },
    }),
  );
}

export function useGuardrailPolicy(
  organizationId: string,
  definitionId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    ...orpc.guardrailPolicies.get.queryOptions({
      input: { organizationId, definitionId },
    }),
    enabled: options?.enabled,
  });
}

export function useCreateGuardrailPolicy() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.guardrailPolicies.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.guardrailPolicies.list.key(),
        });
      },
    }),
  );
}

export function useUpdateGuardrailPolicy() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.guardrailPolicies.update.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.guardrailPolicies.list.key(),
        });
        queryClient.invalidateQueries({
          queryKey: orpc.guardrailPolicies.get.key(),
        });
      },
    }),
  );
}

export function useDeleteGuardrailPolicy() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.guardrailPolicies.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.guardrailPolicies.list.key(),
        });
      },
    }),
  );
}

export function useStepAssignments(
  organizationId: string,
  workflowStepId: string,
) {
  return useQuery(
    orpc.guardrailPolicies.listStepAssignments.queryOptions({
      input: { organizationId, workflowStepId },
    }),
  );
}

export function useSetStepAssignments() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.guardrailPolicies.setStepAssignments.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.guardrailPolicies.listStepAssignments.key(),
        });
      },
    }),
  );
}
